import { Component, OnInit } from '@angular/core';
import { Shift } from 'src/app/classes/shift';
import { ShiftService } from 'src/app/services/shift.service';
import * as fa from '@fortawesome/free-solid-svg-icons';
import { LocationService } from 'src/app/services/location.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EditComponent } from './edit/edit.component';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { Customer } from 'src/app/classes/customer';
import { Employee } from 'src/app/classes/employee';
import { CustomerService } from 'src/app/services/customer.service';
import { ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-shifts',
  templateUrl: './shifts.component.html',
  styleUrls: ['./shifts.component.scss'],
  providers: [DatePipe]
})
export class ShiftsComponent  implements OnInit {
  shifts: Shift[] = []
  customers: Customer[] = []

  shiftsForm = new FormGroup({
    start: new FormControl('', [Validators.required]),
    end: new FormControl('', [Validators.required]),
    customer: new FormControl('all')
  })

  fa = fa

  constructor(
    private shiftService: ShiftService, 
    private titleService: Title,
    private customerService: CustomerService,
    private modalService: NgbModal, 
    private route: ActivatedRoute,
    private datePipe: DatePipe) { }

  ngOnInit() {
    this.titleService.setTitle($localize `Orders`)

    this.shiftsForm.get('start')?.setValue(this.datePipe.transform(new Date().setDate(new Date().getDate() -1), 'yyyy-MM-dd'))
    this.shiftsForm.get('end')?.setValue(this.datePipe.transform(new Date().setDate(new Date().getDate() + 13), 'yyyy-MM-dd'))

    this.customerService.list().subscribe(customers => {
      this.customers = customers
      this.get()
    })
    
    window.scrollTo(0,0)
  }

  get(dontOpen?: boolean){
    this.titleService.setTitle($localize `Orders`)
    
    this.route.params.subscribe(params => {
      if(params['shiftId']) {
        this.shiftService.shift(params['shiftId']).subscribe(shift => {
          this.shifts = [ shift ]

          if(!dontOpen) {
            this.route.queryParams.subscribe(qParams => {
              const modalRef = this.modalService.open(EditComponent, { centered: true, size: 'xl', fullscreen: 'lg', scrollable: true })

              modalRef.componentInstance.shift = shift
              modalRef.componentInstance.askFeedback = qParams['ask_feedback']
          
              this.get(true)

              modalRef.result.then(() => {
                this.get(true)
              })
            })
          }
        })
      }

      else {
        this.shiftService.shifts(this.shiftsForm.value).subscribe(data => {
          this.shifts = data
        })    
      }
    })
  }

  public msToHumanDuration(ms: number): string {
    const minutes = Math.floor(ms / 1000 / 60);
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;

    if (hours === 0) {
      return minutes === 1 
        ? $localize`1 minute`
        : $localize`${minutes} minutes`;
    }

    const hourLabel = hours === 1
      ? $localize`1 hour`
      : $localize`${hours} hours`;
      
    if (remainingMinutes === 0) {
      return hourLabel;
    }

    const minuteLabel = remainingMinutes === 1
      ? $localize`1 minute`
      : $localize`${remainingMinutes} minutes`;

    return `${hourLabel} ${minuteLabel}`;
  }
  
  edit(shift: Shift) {
    const modalRef = this.modalService.open(EditComponent, { centered: true, size: 'xl', fullscreen: 'lg', scrollable: true })

    // Set the shift id on the modal instance
    modalRef.componentInstance.shift = shift

    // When the modal is closed, reload the shifts
    modalRef.result.then(() => {
      this.get(true)
    })
  }
}